module.exports = __webpack_public_path__ + "static/5-6d249f2ce1ac094c9c9c89392f9330b1.png";